import { Component } from "react"

/* Components */
import { InnerLayout, Pagination } from "../../components"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { refunds } from "../../api/Table"

/* Helpers */
import { utils } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Icons */
import {
    CloseIcon, RefundIcon, ReceiptIcon, AdminIcon, CheckIcon, ErrorIcon,
    HourglassIcon, PlayerIcon, ClockIcon, CopyIcon,
} from "../../components/Icons"

/* Clipboard */
import { CopyToClipboard } from "react-copy-to-clipboard"

/* Toast */
import { pushToast } from "../../components/Toast"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* HOW MANY TRANSACTIONS EVERY PAGE HOLDS — getLimit OF THE SERVER ANSWERS WITH TEN */
const SIZE = 10

/* THE STATE OF ONE TRANSACTION */
const STATES = {
    1: { key: "success", icon: CheckIcon, text: () => t("refund.success") },
    2: { key: "error", icon: ErrorIcon, text: () => t("refund.error") },
    0: { key: "pending", icon: HourglassIcon, text: () => t("gtx.pending") },
}


/*
    Widget RoundRefunds — WHAT THE ADMINS GAVE BACK IN ONE ROUND

    Opened by a ref from the round card: open({ uid, round }). The list starts with the refunds
    the admins ran and the name of the one who ran each of them; the whole traffic of the round
    is one chip away, because a refund only makes sense next to the bet it answers.
*/
class RoundRefunds extends Component {

    constructor() {
        super()

        this.state = {
            uid: "",
            round: "",
            visible: false,

            /* refund — only what the admins gave back, all — every transaction of the round */
            scope: "refund",

            data: [],
            stats: null,
            status: "loading",
            page: 1,
            count: 0,
        }
    }

    /* Open Action */
    open = ({ uid, round }) => {

        /* Check Parameters */
        if (!uid || !round) {
            return
        }

        /* Open Modal */
        this.setState({ visible: true, uid, round, scope: "refund", status: "loading", data: [], stats: null, page: 1, count: 0 }, () => {
            this.load()
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false })
    }

    /* Load Action */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { uid, round, scope } = this.state

        /* Check Parameters */
        if (!uid || !round) {
            this.setState({ status: "error", data: [], count: 0 })
            return
        }

        /* Save Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        refunds({ uid, round, page, type: scope }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count, stats: response.data.stats })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }

    /* Change The Scope Of The List */
    setScope = (scope) => {

        /* Check Scope */
        if (scope === this.state.scope) {
            return
        }

        this.setState({ scope }, () => this.load(1, true))
    }

    /* Copy Action */
    copy = () => {
        pushToast({ text: t("settings.tokenCopied"), type: "success" })
    }

    /* Draw The Totals Of The Round */
    _stats = () => {

        /* Fields */
        const { stats, scope } = this.state

        /* Check Stats */
        if (!stats) {
            return null
        }

        return (
            <div className="rnd--refunds-stats">

                <div className="rnd--refunds-stat">
                    <span>{t("refund.refunded")}</span>
                    <p>{parseInt(stats.refunds) > 0 ? parseInt(stats.refunds) : 0}</p>
                </div>

                <div className="rnd--refunds-stat green">
                    <span>{t("refund.success")}</span>
                    <p>{parseInt(stats.success) > 0 ? parseInt(stats.success) : 0}</p>
                </div>

                <div className="rnd--refunds-stat red">
                    <span>{t("gtx.failed")}</span>
                    <p>{parseInt(stats.failed) > 0 ? parseInt(stats.failed) : 0}</p>
                </div>

                <div className="rnd--refunds-stat amber">
                    <span>{t("gtx.pending")}</span>
                    <p>{parseInt(stats.pending) > 0 ? parseInt(stats.pending) : 0}</p>
                </div>

                {/* Only the money that really left the till counts as given back */}
                <div className="rnd--refunds-stat wide">
                    <span>{t("refund.refundedTotal")}</span>
                    <p>{utils.convertor(stats.refundedUSD, "$")}</p>
                </div>

                <div className="rnd--refunds-scope">
                    <div onClick={() => this.setScope("refund")} className={`rnd--chip ${scope === "refund" ? "active" : ""}`}>
                        <RefundIcon size={12} />
                        {t("refund.onlyRefunds")}
                    </div>
                    <div onClick={() => this.setScope("all")} className={`rnd--chip ${scope === "all" ? "active" : ""}`}>
                        <ReceiptIcon size={12} />
                        {t("refund.everything")}
                    </div>
                </div>

            </div>
        )
    }

    /* Draw One Transaction */
    _row = (item, index) => {

        /* Fields */
        const { page } = this.state

        /* Fields */
        const state = STATES[parseInt(item.status)] ? STATES[parseInt(item.status)] : STATES[0]
        const StateIcon = state.icon
        const position = ((page > 0 ? page : 1) - 1) * SIZE + index + 1
        const refund = parseInt(item.isRefund) === 1

        return (
            <div className={`rnd--refund ${state.key}`} key={`${item.id}`}>

                <div className="rnd--refund-head">

                    <div className="rnd--refund-index">{position}</div>

                    <div className="rnd--refund-reason">
                        <h4>
                            {`${utils.checkValue(item.reason)}`.trim() === "" ? `${item.type}`.toUpperCase() : item.reason}
                            {item.box ? ` (BOX ${item.box})` : ""}
                        </h4>
                        <p>
                            <ClockIcon size={11} />
                            {moment(item.createdAt).format("HH:mm:ss, DD MMM YYYY")}
                        </p>
                    </div>

                    <div className={`rnd--refund-state ${state.key}`}>
                        <StateIcon size={11} />
                        {state.text()}
                    </div>

                </div>

                <div className="rnd--refund-cells">

                    {/* Who The Money Belongs To */}
                    <div className="rnd--refund-cell">
                        <span><PlayerIcon size={11} />{t("refund.player")}</span>
                        <p>{`${utils.checkValue(item.firstName)}`.trim() === "" ? item.player : `${item.firstName} · ${item.player}`}</p>
                    </div>

                    {/* Who Gave It Back — an operation of a player carries no admin at all */}
                    <div className="rnd--refund-cell">
                        <span><AdminIcon size={11} />{t("refund.admin")}</span>
                        {refund
                            ? <p className="admin">{`${utils.checkValue(item.admin)}`.trim() === "" ? t("refund.unknownAdmin") : item.admin}</p>
                            : <p className="empty">{t("refund.byPlayer")}</p>
                        }
                    </div>

                    {/* How Much It Was */}
                    <div className="rnd--refund-cell">
                        <span>{t("refund.amount")}</span>
                        <p className={refund ? "violet" : ""}>
                            {utils.convertor(item.total, item.symbol ? item.symbol : item.currency, item.isAfter)}
                            {item.totalUSD ? <b>{utils.convertor(item.totalUSD, "$")}</b> : null}
                        </p>
                    </div>

                    {/* The Wallet Around The Operation */}
                    <div className="rnd--refund-cell">
                        <span>{t("round.balance")}</span>
                        <p>
                            {`${utils.checkValue(item.balanceBefore)}`.trim() === "" && `${utils.checkValue(item.balanceAfter)}`.trim() === ""
                                ? "—"
                                : `${utils.convertor(item.balanceBefore, item.symbol, item.isAfter)} → ${utils.convertor(item.balanceAfter, item.symbol, item.isAfter)}`
                            }
                        </p>
                    </div>

                </div>

                {/* The Number The Operator Knows The Operation By */}
                <CopyToClipboard text={`${utils.checkValue(item.number)}`} onCopy={() => this.copy()}>
                    <div className="rnd--refund-number" title={t("settings.copy")}>
                        <CopyIcon size={11} />
                        {utils.checkValue(item.number, "—")}
                    </div>
                </CopyToClipboard>

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { data, status, scope, page, count } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load(1, true)} />
        }

        /* Empty List */
        if (!data || !Array.isArray(data) || data.length === 0) {
            return (
                <div className="rnd--refunds-empty">
                    <RefundIcon size={26} />
                    <h4>{scope === "refund" ? t("refund.emptyRefunds") : t("layout.empty")}</h4>
                    <p>{scope === "refund" ? t("refund.emptyRefundsDesc") : ""}</p>
                </div>
            )
        }

        return (
            <>
                <div className="rnd--refunds-list">
                    {data.map((item, index) => this._row(item, index))}
                </div>

                <Pagination size={SIZE} page={page} total={count} onPageChange={(value) => this.load(value, true)} />
            </>
        )
    }

    render = () => {

        /* Fields */
        const { visible } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="rnd--modal"
                overlayClassName="rnd--overlay"
                closeTimeoutMS={200}
            >

                <div className="rnd--modal-header">

                    <div className="rnd--modal-icon violet"><RefundIcon size={18} /></div>

                    <div className="rnd--modal-text">
                        <h2>{t("refund.title")}</h2>
                        <p>{t("refund.subtitle")}</p>
                    </div>

                    <div onClick={() => this.close()} className="rnd--modal-close"><CloseIcon size={16} /></div>

                </div>

                <div className="rnd--modal-body">

                    {/* Draw Stats */}
                    {this._stats()}

                    {/* Draw Content */}
                    {this._content()}

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(RoundRefunds)
